import hero from "../../images/about-us-hero.svg"

export default function AboutHero() {
  return (
    <>
      <section className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center xl:max-w-6xl xl:mx-auto py-10 lg:pt-48 lg:pb-20">
        <article>
          <img
            src={hero}
            alt="Our Story"
            title="Our Story"
            className="block mx-auto"
          />
        </article>

        <article>
          <h1 className="mb-1">Our Story</h1>
          <p className="mb-5 lg:text-2xl">
            We started many years ago and grew into a successful and
            fast-growing business created to offer new companies the chance to
            grow big from the start. With our years of development experience,
            we can work with you through the process of creating your company's
            identity. Contact us! We are here to help!
          </p>
          <p className="lg:text-2xl">
            We create cutting-edge tools as solutions to improve brokers'
            productivity and reach more clients. Brokers want to deliver a
            seamless overall experience to their clients, but not many platforms
            meet their expectations.{" "}
          </p>
        </article>
      </section>
    </>
  )
}
